<template>
  <div class="p-postEditor__itemWrapper">
    <div v-if="editingItemIndex !== index" @click="editItem">
      <HtmlTableItemPreview :item="item" />
    </div>
    <item-form v-if="editingItemIndex === index" :item="item">
      <div
        class="pa-2"
        style="width: 100%; border: 1px solid #aaa; border-radius: 3px"
      >
        <div class="d-flex" style="justify-content: space-between">
          <div class="overflow-x-auto pa-4" style="width: 100%">
            <div style="position: relative; padding-bottom: 50px">
              <div
                class="d-flex"
                style="
                  justify-content: space-between;
                  align-items: center;
                  gap: 30px;
                "
              >
                <v-text-field v-model="tableTitle" block style="width: 100%">
                  <template v-slot:label>
                    <InputLabel label-name="表タイトル" :required="false" />
                  </template>
                </v-text-field>
                <v-btn color="primary" tile small @click="switchItemAddBtn">
                  旧・表アイテムを利用する
                </v-btn>
              </div>
              <div
                class="d-flex"
                style="justify-content: space-between; align-items: center"
              >
                <v-switch
                  label="スクロール可能"
                  v-model="scrollable"
                ></v-switch>
                <v-btn-toggle
                  v-if="chosenCells() && scrollable"
                  class="ml-3"
                  dense
                  :value="stickyColumnIndex >= targetRangeStartIndex.x"
                >
                  <v-btn
                    :value="true"
                    @click="setFixedColumnIndex"
                    class="ma-auto"
                    text
                    small
                    >列を固定</v-btn
                  >
                  <v-btn
                    :value="false"
                    @click="removeFixedColumnIndex"
                    class="ma-auto"
                    text
                    small
                    >固定を解除</v-btn
                  >
                </v-btn-toggle>
              </div>
              <div style="position: absolute; bottom: 0">
                <v-row class="pb-2 ma-0" justify="start">
                  <template v-if="chosenCells()">
                    <div
                      class="mr-1 v-item-group theme--light v-btn-toggle v-btn-toggle--dense"
                    >
                      <color-picker-dialog
                        :default-color="chosenCellBackgroundColor"
                        @change-color-code="setCellsBackgroundColor"
                      >
                        <template v-slot:activator="{ on }">
                          <v-btn small outlined v-on="on">
                            <v-icon class="mt-1">mdi-format-color-fill</v-icon>
                          </v-btn>
                        </template>
                      </color-picker-dialog>
                      <EditSizeMenu
                        :height="chosenCellHeight(chosenCellValues)"
                        :width="chosenCellWidth(chosenCellValues)"
                        @update-height="setCellsHeight"
                        @update-width="setCellsWidth"
                      >
                        <template v-slot:activator="{ on }">
                          <v-btn small outlined v-on="on">
                            <v-icon>mdi-move-resize</v-icon>
                            <span>サイズ</span>
                          </v-btn>
                        </template>
                      </EditSizeMenu>
                      <EditPaddingMenu
                        :top="chosenCellPaddingTop(chosenCellValues)"
                        :right="chosenCellPaddingRight(chosenCellValues)"
                        :bottom="chosenCellPaddingBottom(chosenCellValues)"
                        :left="chosenCellPaddingLeft(chosenCellValues)"
                        @update-top="setCellsPaddingTop"
                        @update-right="setCellsPaddingRight"
                        @update-bottom="setCellsPaddingBottom"
                        @update-left="setCellsPaddingLeft"
                      >
                        <template v-slot:activator="{ on }">
                          <v-btn small outlined v-on="on">
                            <v-icon>mdi-aspect-ratio</v-icon>
                            <span>余白</span>
                          </v-btn>
                        </template>
                      </EditPaddingMenu>
                    </div>
                    <v-btn-toggle
                      class="mr-1"
                      dense
                      :value="chosenCellValue.style.textAlign"
                    >
                      <v-btn
                        :value="'left'"
                        @click="setCellsTextAlign('left')"
                        class="ma-auto"
                        text
                        small
                        ><v-icon>mdi-format-align-left</v-icon></v-btn
                      >
                      <v-btn
                        :value="'center'"
                        @click="setCellsTextAlign('center')"
                        class="ma-auto"
                        text
                        small
                        ><v-icon>mdi-format-align-center</v-icon></v-btn
                      >
                      <v-btn
                        :value="'right'"
                        @click="setCellsTextAlign('right')"
                        class="ma-auto"
                        text
                        small
                        ><v-icon>mdi-format-align-right</v-icon></v-btn
                      >
                      <v-btn
                        :value="'justify'"
                        @click="setCellsTextAlign('justify')"
                        class="ma-auto"
                        text
                        small
                        ><v-icon>mdi-format-align-justify</v-icon></v-btn
                      >
                    </v-btn-toggle>
                  </template>
                  <template v-if="chosenColumn()">
                    <div
                      class="mr-1 mt-1 v-item-group theme--light v-btn-toggle v-btn-toggle--dense"
                    >
                      <v-btn
                        @click="createBeforeColumn"
                        class="ma-auto"
                        text
                        small
                        ><v-icon>mdi-plus</v-icon>左に追加</v-btn
                      >
                      <v-btn
                        @click="createAfterColumn"
                        class="ma-auto"
                        text
                        small
                        ><v-icon>mdi-plus</v-icon>右に追加</v-btn
                      >
                      <v-btn
                        @click="copyBeforeColumn"
                        class="ma-auto"
                        text
                        small
                        ><v-icon>mdi-content-copy</v-icon>左に複製</v-btn
                      >
                      <v-btn @click="copyAfterColumn" class="ma-auto" text small
                        ><v-icon>mdi-content-copy</v-icon>右に複製</v-btn
                      >
                      <v-btn @click="deleteColumn" class="ma-auto" text small
                        ><v-icon>mdi-delete</v-icon>列削除</v-btn
                      >
                    </div>
                    <div
                      class="mt-3 v-item-group theme--light v-btn-toggle v-btn-toggle--dense"
                    ></div>
                  </template>
                  <div v-else-if="chosenRow()" class="ml-1">
                    <div
                      class="mr-1 mt-1 v-item-group theme--light v-btn-toggle v-btn-toggle--dense"
                    >
                      <v-btn @click="createBeforeRow" class="ma-auto" text small
                        ><v-icon>mdi-plus</v-icon>上に追加</v-btn
                      >
                      <v-btn @click="createAfterRow" class="ma-auto" text small
                        ><v-icon>mdi-plus</v-icon>下に追加</v-btn
                      >
                      <v-btn @click="copyBeforeRow" class="ma-auto" text small
                        ><v-icon>mdi-content-copy</v-icon>上に複製</v-btn
                      >
                      <v-btn @click="copyAfterRow" class="ma-auto" text small
                        ><v-icon>mdi-content-copy</v-icon>下に複製</v-btn
                      >
                      <v-btn @click="deleteRow" class="ma-auto" text small
                        ><v-icon>mdi-delete</v-icon>行削除</v-btn
                      >
                    </div>
                  </div>
                </v-row>
              </div>
            </div>
            <div class="d-flex flex-wrap">
              <div
                class="pl-6 pt-6 pb-3"
                style="width: calc(100% - 28px); overflow-x: scroll"
              >
                <TableForm
                  :item="item"
                  :index="index"
                  :target-range-start-index="targetRangeStartIndex"
                  :target-range-end-index="targetRangeEndIndex"
                  @select-cell-index="setTargetIndexes"
                />
              </div>
              <v-btn
                class="ml-2"
                tile
                icon
                x-small
                elevation="1"
                style="height: inherit; width: 20px; background-color: #efefef"
                @click="appendColumn"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
              <v-btn
                class="mt-2"
                tile
                icon
                x-small
                elevation="1"
                style="height: 20px; width: 100%; background-color: #efefef"
                @click="appendRow"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </div>
          </div>
        </div>
      </div>
    </item-form>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import itemUtilsMixin from '@/mixins/item_utils'
import InputLabel from '@/components/commons/formParts/inputLabel'
import Cell from './Cell'
import ColorPickerDialog from './ColorPickerDialog'
import EditSizeMenu from './EditSizeMenu'
import EditPaddingMenu from './EditPaddingMenu'
import TableForm from './TableForm'
import HtmlTableItemPreview from '../previews/HtmlTableItemPreview'
import { defaultValue as htmlTableItemValue } from '@/components/postEditor/items/HtmlTableItem/HtmlTableItemDefaultValues'

export default {
  name: 'HtmlTableItem',
  components: {
    HtmlTableItemPreview,
    InputLabel,
    TableForm,
    EditSizeMenu,
    EditPaddingMenu,
    ColorPickerDialog,
    Cell,
    draggable
  },
  mixins: [itemUtilsMixin],
  computed: {
    scrollable: {
      get () {
        return this.editingItemable.scrollable
      },
      set (value) {
        this.updateEditingItemable(value, 'scrollable')
      }
    },
    tableTitle: {
      get () {
        return this.editingItemable.tableTitle
      },
      set (value) {
        this.updateEditingItemable(value, 'tableTitle')
      }
    },
    tableContent: {
      get () {
        return [...this.editingItemable.htmlTableContent]
      },
      set (value) {
        this.updateEditingItemable(value, 'htmlTableContent')
      }
    },
    initialCell () {
      return htmlTableItemValue()
    },
    initializeRowValues () {
      return this.tableContent[0].map((_) => this.initialCell)
    },
    chosenColumnValues () {
      return (
        this.tableContent.map((row) => row[this.targetRangeStartIndex.x]) || []
      )
    },
    chosenRowValues () {
      return this.tableContent[this.targetRangeStartIndex.y] || []
    },
    chosenCellValues () {
      if (this.chosenColumn()) {
        return this.chosenColumnValues
      }
      if (this.chosenRow()) {
        return this.chosenRowValues
      }
      return [this.chosenCellValue]
    },
    chosenCellValue () {
      if (this.chosenColumn() || this.chosenRow()) return this.initialCell
      return (
        this.tableContent[this.targetRangeStartIndex.y][this.targetRangeStartIndex.x] || this.initialCell
      )
    },
    chosenCellBackgroundColor () {
      return this.chosenCellValue.style.backgroundColor || ''
    },
    stickyColumnIndex () {
      return this.editingItemable.tableColumnFixed
    }
  },
  data () {
    return {
      targetRangeStartIndex: { y: -1, x: -1 },
      targetRangeEndIndex: { y: -1, x: -1 }
    }
  },
  methods: {
    switchItemAddBtn () {
      if (
        confirm(
          '旧・表アイテムを利用すると既存のデータ消えます。本当に変更しますか？'
        )
      ) {
        this.switchItem('table_item', this.index)
      }
    },
    setTargetIndexes (indexes) {
      const inTableIndexRowRange = (index) =>
        index >= -1 && index <= this.tableContent.length - 1
      const inTableIndexColumnRange = (index) =>
        index >= -1 && index <= this.tableContent[0].length - 1

      if (
        inTableIndexRowRange(indexes.start.y) &&
        inTableIndexColumnRange(indexes.start.x)
      ) {
        this.targetRangeStartIndex.x = indexes.start.x
        this.targetRangeStartIndex.y = indexes.start.y
      }
      if (
        inTableIndexRowRange(indexes.end.y) &&
        inTableIndexColumnRange(indexes.end.x)
      ) {
        this.targetRangeEndIndex.x = indexes.end.x
        this.targetRangeEndIndex.y = indexes.end.y
      }
    },
    setFixedColumnIndex () {
      this.updateEditingItemable(
        Math.max(this.targetRangeStartIndex.x, this.targetRangeEndIndex.x),
        'tableColumnFixed'
      )
    },
    removeFixedColumnIndex () {
      this.updateEditingItemable(-1, 'tableColumnFixed')
    },
    appendColumn () {
      this.createColumn(this.tableContent[0].length, [])
    },
    appendRow () {
      this.createRow(this.tableContent.length, this.initializeRowValues)
    },
    copyBeforeColumn () {
      this.createColumn(
        this.targetRangeStartIndex.x,
        this.chosenColumnValues.map((cell) => ({ ...cell }))
      )
      this.chooseColumnFrom(this.targetRangeStartIndex.x + 1)
    },
    copyAfterColumn () {
      this.createColumn(
        this.targetRangeStartIndex.x,
        this.chosenColumnValues.map((cell) => ({ ...cell }))
      )
    },
    createBeforeColumn () {
      this.createColumn(this.targetRangeStartIndex.x, [])
      this.chooseColumnFrom(this.targetRangeStartIndex.x + 1)
    },
    createAfterColumn () {
      this.createColumn(this.targetRangeStartIndex.x + 1, [])
    },
    createColumn (index, cells) {
      this.tableContent = this.tableContent.map((row, rowIndex) => {
        const copyRow = [...row]
        copyRow.splice(index, 0, cells[rowIndex] || this.initialCell)
        return copyRow
      })
    },
    copyBeforeRow () {
      this.createRow(
        this.targetRangeStartIndex.y,
        this.chosenRowValues.map((cell) => ({ ...cell }))
      )
      this.chooseRowFrom(this.targetRangeStartIndex.y + 1)
    },
    copyAfterRow () {
      this.createRow(
        this.targetRangeStartIndex.y + 1,
        this.chosenRowValues.map((cell) => ({ ...cell }))
      )
    },
    createBeforeRow () {
      this.createRow(this.targetRangeStartIndex.y, this.initializeRowValues)
      this.chooseRowFrom(this.targetRangeStartIndex.y + 1)
    },
    createAfterRow () {
      this.createRow(this.targetRangeStartIndex.y + 1, this.initializeRowValues)
    },
    createRow (index, cells) {
      const copyContent = [...this.tableContent]
      copyContent.splice(index, 0, cells)
      this.tableContent = copyContent
    },
    chooseColumnFrom (index) {
      this.chooseRangeStartCellFrom(-1, index)
    },
    chosenCellIndexIs (y, x) {
      if (
        this.targetRangeEndIndex.x !== -1 &&
        this.targetRangeEndIndex.y !== -1 &&
        this.targetRangeStartIndex.x !== -1 &&
        this.targetRangeStartIndex.y !== -1
      ) {
        return (
          Math.min(this.targetRangeEndIndex.y, this.targetRangeStartIndex.y) <=
            y &&
          y <=
            Math.max(
              this.targetRangeEndIndex.y,
              this.targetRangeStartIndex.y
            ) &&
          Math.min(this.targetRangeEndIndex.x, this.targetRangeStartIndex.x) <=
            x &&
          x <=
            Math.max(this.targetRangeEndIndex.x, this.targetRangeStartIndex.x)
        )
      }
      if (this.targetRangeStartIndex.y === -1) {
        return this.targetRangeStartIndex.x === x
      }
      if (this.targetRangeStartIndex.x === -1) {
        return this.targetRangeStartIndex.y === y
      }
      return false
    },
    chooseRangeStartCellFrom (y, x) {
      this.targetRangeStartIndex.x = x
      this.targetRangeStartIndex.y = y
      this.targetRangeEndIndex.x = -1
      this.targetRangeEndIndex.y = -1
    },
    chooseRangeEndCellFrom (y, x) {
      this.targetRangeEndIndex.x = x
      this.targetRangeEndIndex.y = y
    },
    setEditingIndex (y, x) {
      this.editingIndex.x = x
      this.editingIndex.y = y
    },
    chosenColumn () {
      return (
        this.targetRangeStartIndex.x !== -1 &&
        this.targetRangeStartIndex.y === -1
      )
    },
    chooseRowFrom (index) {
      this.chooseRangeStartCellFrom(index, -1)
    },
    chosenRow () {
      return (
        this.targetRangeStartIndex.y !== -1 &&
        this.targetRangeStartIndex.x === -1
      )
    },
    chosenCells () {
      return (
        this.targetRangeStartIndex.y !== -1 ||
        this.targetRangeStartIndex.x !== -1
      )
    },
    deleteColumn () {
      if (this.tableContent[0].length <= 1) return

      this.tableContent = this.tableContent.map((row) => {
        const copyRow = [...row]
        copyRow.splice(this.targetRangeStartIndex.x, 1)
        return copyRow
      })
    },
    deleteRow () {
      if (this.tableContent.length <= 1) return

      const content = this.tableContent
      content.splice(this.targetRangeStartIndex.y, 1)
      this.tableContent = content
    },
    chosenCellWidth (values) {
      return Math.max(
        ...values.map((value) => (value ? value.style['width'] || 0 : 0))
      )
    },
    chosenCellHeight (values) {
      return Math.max(
        ...values.map((value) => (value ? value.style['height'] || 0 : 0))
      )
    },
    chosenCellPaddingTop (values) {
      return Math.max(
        ...values.map((value) => (value ? value.style['paddingTop'] || 0 : 0))
      )
    },
    chosenCellPaddingRight (values) {
      return Math.max(
        ...values.map((value) => (value ? value.style['paddingRight'] || 0 : 0))
      )
    },
    chosenCellPaddingBottom (values) {
      return Math.max(
        ...values.map((value) =>
          value ? value.style['paddingBottom'] || 0 : 0
        )
      )
    },
    chosenCellPaddingLeft (values) {
      return Math.max(
        ...values.map((value) => (value ? value.style['paddingLeft'] || 0 : 0))
      )
    },
    setCellsWidth (width) {
      this.tableContent.map((row, rowIndex) => {
        row.map((cell, cellIndex) => {
          if (!this.chosenCellIndexIs(rowIndex, cellIndex)) return
          this.setCellStyle(cellIndex, rowIndex, {
            width: width,
            height: cell.style.height
          })
        })
      })
    },
    setCellsHeight (height) {
      this.tableContent.map((row, rowIndex) => {
        row.map((cell, cellIndex) => {
          if (!this.chosenCellIndexIs(rowIndex, cellIndex)) return
          this.setCellStyle(cellIndex, rowIndex, {
            width: cell.style.width,
            height: height
          })
        })
      })
    },
    setCellsPaddingTop (value) {
      this.tableContent.map((row, rowIndex) => {
        row.map((cell, cellIndex) => {
          if (!this.chosenCellIndexIs(rowIndex, cellIndex)) return
          this.setCellStyle(cellIndex, rowIndex, {
            paddingTop: value
          })
        })
      })
    },
    setCellsPaddingRight (value) {
      this.tableContent.map((row, rowIndex) => {
        row.map((cell, cellIndex) => {
          if (!this.chosenCellIndexIs(rowIndex, cellIndex)) return
          this.setCellStyle(cellIndex, rowIndex, {
            paddingRight: value
          })
        })
      })
    },
    setCellsPaddingBottom (value) {
      this.tableContent.map((row, rowIndex) => {
        row.map((cell, cellIndex) => {
          if (!this.chosenCellIndexIs(rowIndex, cellIndex)) return
          this.setCellStyle(cellIndex, rowIndex, {
            paddingBottom: value
          })
        })
      })
    },
    setCellsPaddingLeft (value) {
      this.tableContent.map((row, rowIndex) => {
        row.map((cell, cellIndex) => {
          if (!this.chosenCellIndexIs(rowIndex, cellIndex)) return
          this.setCellStyle(cellIndex, rowIndex, {
            paddingLeft: value
          })
        })
      })
    },
    setCellsBackgroundColor (backgroundColor) {
      this.tableContent.map((row, rowIndex) => {
        row.map((cell, cellIndex) => {
          if (!this.chosenCellIndexIs(rowIndex, cellIndex)) return
          this.setCellStyle(cellIndex, rowIndex, {
            backgroundColor: backgroundColor
          })
        })
      })
    },
    setCellsTextAlign (value) {
      this.tableContent.map((row, rowIndex) => {
        row.map((cell, cellIndex) => {
          if (!this.chosenCellIndexIs(rowIndex, cellIndex)) return
          this.setCellStyle(cellIndex, rowIndex, { textAlign: value })
        })
      })
    },
    setCellStyle (x, y, overwriteStyles) {
      const copyContent = [...this.tableContent]
      copyContent[y] = [...copyContent[y]]
      copyContent[y][x] = {
        ...copyContent[y][x],
        style: {
          ...copyContent[y][x].style,
          ...overwriteStyles
        }
      }
      this.tableContent = copyContent
    }
  }
}
</script>
